<template>
  <div class="list-new">
    <!-- search input -->
    <section id="knowledge-base-search">
      <b-card :style="{
        backgroundImage: `url(${require('@/assets/images/banner/banner.png')})`,
      }" class="knowledge-base-bg text-center" no-body>
        <b-card-body>
          <b-row class="pb-1">
            <b-col cols="12">
              <b-tabs>
                <b-tab active title="Tra cứu thông tin" @click="changeTab(1)">
                </b-tab>
                <b-tab title="Hot news" @click="changeTab(2)">
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
          <b-row v-if="tabActive == 1" class="content-cat">
            <div class="left">
              <b-row>
                <b-col cols="12">
                  <div class="title-cat">Danh mục</div>
                </b-col>
              </b-row>
              <b-row class="mt-50">
                <b-col cols="12">
                  <v-jstree :data="categoryList" allow-batch icons="false" multiple no-dots show-checkbox
                            whole-row @item-click="checkedClick">
                    <template scope="_">
                      <div style="display: inherit; width: 200px" @click.exact="itemClick(_.vm, $event)"
                           @contextmenu.prevent="$refs.ctx.open($event, _.vm)">
                        <i v-if="!_.model.loading && !!_.model.icon" :class="_.vm.themeIconClasses"
                           role="presentation"></i>
                        {{ _.model.text }}
                        <button style="border: 0px; background-color: transparent; cursor: pointer;"><i
                            class="fa fa-remove"></i></button>
                      </div>
                    </template>
                  </v-jstree>
                </b-col>
              </b-row>
            </div>
            <div class="right">
              <b-row>
                <b-col cols="12">
                  <b-row>
                    <b-col class="text-left" cols="12">
                      <b-input-group class="input-group-merge">
                        <b-input-group-prepend is-text>
                          <feather-icon icon="SearchIcon"/>
                        </b-input-group-prepend>
                        <b-form-input id="searchbar" v-model="searchQuery" class="search-new"
                                      placeholder="Tìm kiếm theo từ khóa...." v-on:keydown.enter="quickSearch"/>
                      </b-input-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col v-if="listNews.length > 0" class="mt-20" cols="12">
                  <b-list-group class="list-group-circle mt-2  ">
                    <b-list-group-item v-for="item in listNews" :key="item.id" v-b-tooltip.hover.html="item.contents"
                                       class="list-group-item text-body item-new"
                                       v-bind:class="{ 'active': isSelected(item.id) }"
                                       v-on:click="detailClick(item)">
                      <span :style="[item.isRead ? { opacity: 0.5 } : { opacity: 1 }]">{{ item.Index }}. {{ item.name }}
                      </span>

                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>
            </div>
          </b-row>
          <b-row v-if="tabActive == 2" class="content-cat">
            <b-col cols="12">
              <HotNew/>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </section>
    <b-modal id="modal-hot-new" hide-footer hide-header no-close-on-backdrop no-close-on-esc size="xl" title="">
      <div class="use-new" style="border: 2px solid #73af4b;margin: 10px 0; padding:10px">
        <div class="hot-new">
          <div class="hot-img text-left">
            <img :src="require('@/assets/images/banner/hot_new_icon.png')"/>
          </div>
          <div class="hot-grid text-left">
            <div v-if="totalRecordHot == 0">
              <b-form-group>
                <label>Hôm nay không có gì Hot cả.</label>
                <br>
                <label> Chúc bạn một ngày làm việc vui vẻ nhé!</label>
              </b-form-group>
            </div>

            <vue-good-table :columns="options.fields" :isLoading.sync="isLoading" :line-numbers="true" :pagination-options="{ perPage: serverParams.pageSize, enabled: true, perPageDropdown: [20, 50, 100], dropdownAllowAll: false }"
                            :rows="listHotNews" :totalRows="totalRecordHot"
                            mode="remote"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange">
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'name'">
                  <span v-title="props.row.contents"
                        :style="[props.row.isRead ? { opacity: 0.5 } : { opacity: 1 }]"
                        style="font-weight: bold; color: blue; cursor: pointer; line-height: 30px;" @click="detailClick(props.row)">{{ props.row.name }}</span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>

            <div class="mt-50" style="height: 40px">&nbsp;</div>
            <b-row class="mt-50">
              <b-col class="text-right  mt-50" cols="12">
                <label>Ok, mình đã tiếp nhận tín hiệu từ vũ trụ iTel rồi nhé!</label>

                <img :src="require('@/assets/images/banner/btn_hot_confirm.png')" class="img-btn" @click="confirm"/>
                <br/>
                <label class="confirm-text text-right">Xác nhận thì thả tim</label>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- chính sách + quy trình quy định -->
    <b-modal id="modal-view" :title="getTitle()" scrollable size="sm" @ok="handleOk">
      <b-row class="use-new">
        <b-col class="view-left mt-50" cols="4">
          <!-- <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Ngày hiệu lực: </label>
                <label class="ml-50"> {{ currentItem.effect_date }}</label>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Phòng ban chủ trì: </label>
                <label class="ml-50"> {{ currentItem.department_presiding_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Phòng ban tham gia: </label>
                <label class="ml-50"> {{ currentItem.department_join_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="currentItem.cate_type_new == 0 || currentItem.cate_type_new == 1">
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Người soạn thảo: </label>
                <label class="ml-50"> {{ currentItem.creator_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row v-if="currentItem.cate_type_new == 0 || currentItem.cate_type_new == 1">
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Người phê duyệt: </label>
                <label class="ml-50"> {{ currentItem.approver }}</label>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="mt-50 border-left" cols="8">
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Đối tượng áp dụng: </label>
                <label class="ml-50"> {{ currentItem.applicable_object }}</label>
              </b-form-group>
            </b-col>

            <b-col v-if="currentItem.cat_type_new == 1" cols="12">
              <b-form-group>
                <label class="font-bold">Trường hợp áp dụng: </label>
                <label class="ml-50"> {{ currentItem.applicable_cases }}</label>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <!-- eslint-disable vue/no-v-html -->
                <div class="question-content" v-html="currentItem.contents"/>
                <!-- eslint-enable -->
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                             @click="downloadFile(currentItem.file_path)">
                <div class="sample-file__download">
                  <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
                </div>
                {{ currentItem.file_path }}
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <!-- kt chính sách + quy trình -->
    <!-- khuyến mại -->
    <b-modal id="modal-view-promotion" :title="getTitle()" scrollable size="xl" @ok="handleOk">
      <b-row class="use-new">
        <b-col class="view-left mt-50" cols="4">
          <!-- <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Ngày hiệu lực: </label>
                <label class="ml-50"> {{ currentItem.effect_date }}</label>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Phòng ban chủ trì: </label>
                <label class="ml-50"> {{ currentItem.department_presiding_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Phòng ban tham gia: </label>
                <label class="ml-50"> {{ currentItem.department_join_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Đối tượng áp dụng: </label>
                <label class="ml-50"> {{ currentItem.applicable_object }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Phạm vi áp dụng: </label>
                <label class="ml-50"> {{ currentItem.application_scope }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Hình thức triển khai: </label>
                <label class="ml-50"> {{ currentItem.deployment_form }}</label>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="mt-50 border-left" cols="8">
          <b-row>
            <b-col class="not-padding-r " cols="6">
              <b-form-group class=" margin-b">
                <label class="font-bold">Ngày bắt đầu: </label>
                <label class="ml-50"> {{ currentItem.from_date }}</label>
              </b-form-group>
            </b-col>
            <b-col class="not-padding " cols="6">
              <b-form-group class="border-left margin-b">
                <label class="font-bold" style="padding-left:20px">Ngày kết thúc: </label>
                <label class="ml-50"> {{ currentItem.to_date }}</label>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group style="border:none; padding-top:15px">
                <!-- eslint-disable vue/no-v-html -->
                <div class="question-content" v-html="currentItem.contents"/>
                <!-- eslint-enable -->
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                             @click="downloadFile(currentItem.file_path)">
                <div class="sample-file__download">
                  <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
                </div>
                {{ currentItem.file_path }}
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>
    <!-- kt khuyến mại -->
    <!-- Hướng dẫn sử dụng -->
    <b-modal id="modal-view-help" :title="getTitle()" scrollable size="xl" @ok="handleOk">
      <b-row class="mt-50 use-new">
        <b-col cols="12">
          <b-form-group>
            <label class="font-bold">Mục đích: </label>
            <label class="ml-50"> {{ currentItem.purposes }}</label>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group>
            <label class="font-bold">Đối tượng áp dụng: </label>
            <label class="ml-50"> {{ currentItem.applicable_object }}</label>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group style="border:none">
            <!-- eslint-disable vue/no-v-html -->
            <div class="question-content" v-html="currentItem.contents"/>
            <!-- eslint-enable -->
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                         @click="downloadFile(currentItem.file_path)">
            <div class="sample-file__download">
              <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
            </div>
            {{ currentItem.file_path }}
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="mt-50">&nbsp;</b-row>
      <b-row class="text-left mt-50 ">
        <b-button class="btn-sm mr-50 ml-50" variant="primary" @click="showFeedback(currentItem)">
          <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
          Gửi đề xuất góp ý
        </b-button>
      </b-row>
    </b-modal>
    <!-- Hướng dẫn sử dụng -->
    <!-- Gửi nội dung feedback -->
    <b-modal id="modal-feedback" scrollable size="xl" title="Gửi ý kiến phản hồi" @ok="handleFeedbackOk">
      <b-row class="mt-50 ">
        <b-col cols="12">
          <b-form-group>
            <label class="font-bold">Thuộc: </label>
            <label class="ml-50"> {{ feedbackItem.newName }}</label>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <ckeditor id="textarea-auto-height" v-model="feedbackItem.contents"
                    class="editor-form" editor-url='https://cdn.ckeditor.com/4.20.0/full/ckeditor.js'
                    placeholder="Nhập đề xuất của bạn"></ckeditor>

          <!-- <b-form-textarea id="textarea-auto-height" placeholder="Nhập đề xuất của bạn" rows="8"
            v-model="feedbackItem.contents" max-rows="8" /> -->
        </b-col>
        <b-col class="mt-50 text-left" cols="12">
          <div v-if="feedbackItem && feedbackItem.file_path">
            {{ feedbackItem.file_path }}
          </div>
          <b-form-file v-model="feedbackItem.file" accept="application/pdf,application/vnd.ms-excel,application/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document" plain
                       v-on:input="uploadFile">
          </b-form-file>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-pack" :title="getTitle()" scrollable size="xl" @ok="handleOk">
      <b-row class="use-new">
        <b-col class="view-left mt-50" cols="4">
          <!-- <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Ngày hiệu lực: </label>
                <label class="ml-50"> {{ currentItem.effect_date }}</label>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Phòng ban chủ trì: </label>
                <label class="ml-50"> {{ currentItem.department_presiding_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Phòng ban tham gia: </label>
                <label class="ml-50"> {{ currentItem.department_join_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Người soạn thảo: </label>
                <label class="ml-50"> {{ currentItem.creator_name }}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Người phê duyệt: </label>
                <label class="ml-50"> {{ currentItem.approver }}</label>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="mt-50 border-left" cols="8">
          <b-row>
            <b-col class="not-padding-r" cols="4">
              <b-form-group>
                <label class="font-bold">Cước phí: </label>
                <label class="ml-50"> {{ currentItem.postage | number }} vnđ</label>
              </b-form-group>
            </b-col>

            <b-col class="not-padding " cols="4">
              <b-form-group class="border-lr text-center">
                <label class="font-bold">Chu kỳ: </label>
                <label class="ml-50"> {{ currentItem.duration }} ngày</label>
              </b-form-group>
            </b-col>
            <b-col class="not-padding" cols="4">
              <b-form-group style="padding-left: 20px;">
                <label class="font-bold">Gói nền: </label>
                <label class="ml-50"> {{ currentItem.package_daemon }}</label>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <b-form-group>
                <!-- eslint-disable vue/no-v-html -->
                <div class="question-content" v-html="currentItem.contents"/>
                <!-- eslint-enable -->
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Cách đăng ký: </label>
                <label class="ml-50"> {{ currentItem.how_to_register }}</label>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group>
                <label class="font-bold">Gói bổ sung: </label>
                <label class="ml-50"> {{ currentItem.pack_extra }}</label>
              </b-form-group>
            </b-col>
            <b-col cols="12">

              <b-input-group v-if="currentItem && currentItem.file_path" class="input-group-merge"
                             @click="downloadFile(currentItem.file_path)">
                <div class="sample-file__download">
                  <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
                </div>
                {{ currentItem.file_path }}
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal id="modal-qa" :title="getTitle()" scrollable size="xl" @ok="handleOk">
      <b-row class="mt-50 use-new">
        <b-col cols="12">
          <b-form-group>
            <label class="font-bold">Nội dung câu hỏi: </label>
            <div class="question-content ml-50" v-html="currentItem.question"/>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group>
            <!-- eslint-disable vue/no-v-html -->
            <div class="question-content" v-html="currentItem.answer"/>
            <!-- eslint-enable -->
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-input-group v-if="currentItem && currentItem.question_file" class="input-group-merge"
                         @click="downloadFile(currentItem.question_file)">
            <div class="sample-file__download">
              <feather-icon icon="DownloadIcon" style="margin-right: 8px;"/>
            </div>
            {{ currentItem.question_file }}
          </b-input-group>
        </b-col>
      </b-row>
      <b-row class="mt-50">&nbsp;</b-row>
      <b-row class="text-left mt-50">
        <b-button class="btn-sm mr-50 ml-50" variant="primary" @click="showFeedback(currentItem)">
          <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
          Gửi đề xuất góp ý
        </b-button>
        <b-button class="btn-sm mr-50 ml-50" variant="primary" @click="showSMS(currentItem)">
          <feather-icon class="align-text-top" icon="PlusIcon" size="16"/>
          Gửi SMS
        </b-button>
      </b-row>
    </b-modal>
    <!-- Gửi sms -->
    <b-modal id="modal-sms" scrollable size="xl" title="Gửi sms" @ok="handleSMSOk">
      <b-row class="mt-50 ">
        <b-col cols="12">
          <b-form-group>
            <label class="font-bold">Số điện thoại nhận (iTel) </label>
            <input v-model="smsItem.phone" class="phone-re"
                   maxlength="10"
                   onKeyDown="if(this.value.length==10 && event.keyCode>47 && event.keyCode < 58) return false;" type="number"/>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-textarea id="textarea-auto-height" v-model="smsItem.contents" max-rows="8" placeholder="Nhập nội dung SMS"
                           rows="8"/>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCardBody,
  BCardText,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BInputGroup,
  BInputGroupPrepend,
  BListGroup,
  BListGroupItem,
  BRow,
  BTab,
  BTabs,
  VBTooltip
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import HotNew from "./../portal/HotNews.vue"
import {getuserName, TypeCategories} from '@/@core/utils/utils';
import {VueGoodTable} from "vue-good-table";
import moment from "moment";
import VJstree from 'vue-jstree'
import Vue from 'vue';
import CKEditor from 'ckeditor4-vue';

const imgUrl = require("@/assets/images/illustration/marketing.svg");

Vue.use(CKEditor, {
  toolbar: [],
  toolbarGroups: []
});
export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BCardText,
    BForm,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BTabs,
    BTab,
    HotNew,
    BListGroup,
    BListGroupItem,
    BFormGroup,
    VueGoodTable,
    VJstree,
    VBTooltip,
    BFormFile,
    BButton,
    BFormTextarea
  },

  data() {
    return {
      imgUrl: imgUrl,
      tabActive: 1,
      searchQuery: '',
      categoryList: [],
      listHotNews: [],
      searchHot: "",
      listNews: [],
      currentItem: {},
      selected: 0,
      modal_title: "",
      feedbackItem: {},
      emalConfigs: [],
      totalRecords: 0,
      totalRecordHot: 0,
      isLoading: false,
      smsItem: {},
      catSelects: [],
      options: {
        fields: [
          {
            field: "catName",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Nhóm danh mục",
            required: true
          },
          {
            field: "name",
            filterOptions: {enabled: true, placeholder: "", trigger: 'enter'},
            label: "Nội dung",
            required: true
          },
          {
            field: "effect_date",
            filterOptions: {enabled: false, placeholder: ""},
            label: "Ngày áp dụng",
            type: 'date',
            dateInputFormat: 'yyyy-MM-dd',
            dateOutputFormat: 'dd/MM/yyyy',
            disabled: true
          }
        ]
      },
      serverParams: {
        "columnFilters": {},
        "sort": [
          {"field": "created_date", "type": "desc"}
        ],
        "page": 1,
        "pageSize": 20,
        "lang": 1
      },
    };
  },
  computed: {},
  mounted() {
    this.isSubmit = false;
    this.hotNew();
    this.loadCategories();
    this.loadEmailConfig();
  },
  created() {
  },

  methods: {
    getTitle() {
      return this.modal_title;
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({page: params.currentPage});
      this.fetchHotNews();
    },
    onPerPageChange(params) {
      this.updateParams({pageSize: params.currentPerPage});
      this.fetchHotNews();
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      });
      this.fetchHotNews();
    },
    onColumnFilter(params) {
      this.serverParams.page = 1;
      this.updateParams(params);
      console.log(this.serverParams);
      this.fetchHotNews();
    },

    quickSearch() {
      this.fetchNews();
    },

    getTopicIdSelectd() {
      var topicIds = [];
      if (this.categoryList && this.categoryList.length > 0) {
        this.categoryList.forEach(function (item) {
          if (item.children && item.children.length > 0) {
            item.children.forEach(function (itemChi) {
              if (itemChi.selected) {
                topicIds.push(itemChi.id);
              }
            });
          }

        });
      }
      return topicIds.join(',');
    },
    fetchNews() {
      try {
        var topicIds = this.getTopicIdSelectd();
        if (!this.searchQuery && topicIds == "") {
          this.listNews = [];
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Bạn phải nhập thông tin tìm kiếm hoặc chọn chủ đề cần xem.',
              icon: "AlertTriangleIcon",
              variant: "warning",
            },
          });
          return;
        }
        this.loading(true);
        useJwt
            .get("portal/getListNews?filter=" + this.searchQuery + '&topicIds=' + topicIds)
            .then((response) => {
              if (response.data.code == 200) {
                this.listNews = response.data.result;
                for (var i = 0; i < this.listNews.length; i++) {
                  this.listNews[i]['Index'] = i + 1;
                }
                this.totalRecords = response.data.totalRecords;
              }
              this.isLoading = false;
              this.loading(false);
            })
            .catch((err) => {
              this.loading(false);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: err.response?.data?.message,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            });
      } catch {
        this.loading(false);
      }
    },
    fetchHotNews() {
      this.loading(true);
      this.serverParams.columnFilters.lastDay = 2;
      let data = {
        ...this.serverParams,
        columnFilters: {
          ...(this.serverParams.columnFilters ? this.serverParams.columnFilters : [])
        }
      }
      if (data.columnFilters.created_date != undefined) {
        delete data.columnFilters['created_date_']
      }
      useJwt
          .post("portal/HotNews", data)
          .then((response) => {
            if (response.data.code == 200) {
              this.listHotNews = response.data.result;
              this.totalRecordHot = response.data.totalRecords;
            }
            this.isLoading = false;
            this.loading(false);
          })
          .catch((err) => {
            this.loading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: err.response?.data?.message,
                icon: "AlertTriangleIcon",
                variant: "warning",
              },
            });
          });
    },
    changeTab(tab) {
      this.tabActive = tab;
    },

    hotNew() {
      try {
        this.loading(true);
        useJwt.get("portal/getconfirm").then((response) => {
          var result = response.data;
          if (result.code == 200) {
            if (!result.result || result.result.length == 0) {
              this.fetchHotNews();
              this.$bvModal.show("modal-hot-new");
            }
          }
          this.loading(false);
        });
      } catch {
        this.loading(false);
      }

    },
    async loadCategories() {
      useJwt.get("portal/getAllCategories").then((response) => {
        var result = response.data;
        if (result.code == 200) {
          const listChildren = [];
          const self = this;
          result.result.forEach(item => {
            item.text = item.name;
            if (item.cat_type == 0) {
              item.opened = false;
              item.disabled = true;
              // item.isLeaf=true;
              self.categoryList.push(item);
            } else {
              // item.isfolder=true;
              listChildren.push(item);
            }
          });
          self.categoryList.forEach(item => {
            item.children = listChildren.filter(function (chi) {
              return chi.parent_id == item.id
            });
          });
        }
        this.isLoading = false;
        this.loading(false);
      });
    },
    detailClick(row) {
      const id = row.id;
      this.loading(true);
      if (row.cat_type_new == TypeCategories.PACKDATA) {
        useJwt
            .get("portal/getpackdatabyById?id=" + id)
            .then((response) => {
              if (response.data.code == 200) {
                row.isRead = true;
                this.currentItem = response.data.result[0];
                this.currentItem.effect_date = this.formatDate(this.currentItem.effect_date);
                if (this.currentItem.from_date) {
                  this.currentItem.from_date = this.formatDate(this.currentItem.from_date);
                }
                if (this.currentItem.to_date) {
                  this.currentItem.to_date = this.formatDate(this.currentItem.to_date);
                }
                this.modal_title = this.currentItem.name;

                if (this.currentItem.contents && this.currentItem.contents.indexOf('<p>') < 0 && this.currentItem.contents.indexOf("<ul>") < 0 && this.currentItem.contents.indexOf('<li>')) {
                  this.currentItem.contents = '<div class="question-content-break">' + this.currentItem.contents + "</div>";
                }
                this.$bvModal.show("modal-pack");

              }
              this.loading(false);
            })
            .catch((err) => {
              this.loading(false);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: err.response?.data?.message,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            });
      } else if (row.cat_type_new == TypeCategories.QA) {
        useJwt
            .get("portal/getQAbyById?id=" + id)
            .then((response) => {
              if (response.data.code == 200) {
                this.currentItem = response.data.result[0];
                this.currentItem.effect_date = this.formatDate(this.currentItem.effect_date);
                if (this.currentItem.from_date) {
                  this.currentItem.from_date = this.formatDate(this.currentItem.from_date);
                }
                if (this.currentItem.to_date) {
                  this.currentItem.to_date = this.formatDate(this.currentItem.to_date);
                }

                if (this.currentItem.answer && this.currentItem.answer.indexOf('<p>') < 0 && this.currentItem.answer.indexOf("<ul>") < 0 && this.currentItem.answer.indexOf('<li>') < 0) {
                  this.currentItem.answer = '<div class="question-content-break">' + this.currentItem.answer + "</div>";
                }
                if (this.currentItem.question && this.currentItem.question.indexOf('<p>') < 0 && this.currentItem.question.indexOf("<ul>") < 0 && this.currentItem.question.indexOf('<li>') < 0) {
                  this.currentItem.question = '<div class="question-content-break">' + this.currentItem.question + "</div>";
                }
                if (this.currentItem.reason.indexOf('<p>') < 0 && this.currentItem.reason.indexOf("<ul>") < 0 && this.currentItem.reason.indexOf('<li>') < 0) {
                  this.currentItem.reason = '<div class="question-content-break">' + this.currentItem.reason + "</div>";
                }
                this.modal_title = this.currentItem.answer;
                this.$bvModal.show("modal-qa");
              }
              this.loading(false);
            })
            .catch((err) => {
              this.loading(false);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: err.response?.data?.result,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            });
      } else {
        useJwt
            .get("portal/getnewsgroupById?id=" + id)
            .then((response) => {
              if (response.data.code == 200) {
                this.currentItem = response.data.result[0];
                this.currentItem.effect_date = this.formatDate(this.currentItem.effect_date);
                if (this.currentItem.from_date) {
                  this.currentItem.from_date = this.formatDate(this.currentItem.from_date);
                }
                if (this.currentItem.to_date) {
                  this.currentItem.to_date = this.formatDate(this.currentItem.to_date);
                }
                this.modal_title = this.currentItem.name;
                if (this.currentItem.contents && this.currentItem.contents.indexOf('<p>') < 0 && this.currentItem.contents.indexOf("<ul>") < 0 && this.currentItem.contents.indexOf('<li>')) {
                  this.currentItem.contents = '<div class="question-content-break">' + this.currentItem.contents + "</div>";
                }
                if (this.currentItem.cat_type_new == TypeCategories.POLICY || this.currentItem.cat_type_new == TypeCategories.PROCESS_REGULATIONS) {
                  this.$bvModal.show("modal-view");
                } else if (this.currentItem.cat_type_new == TypeCategories.PROMOTION) {
                  this.$bvModal.show("modal-view-promotion");
                } else if (this.currentItem.cat_type_new == TypeCategories.HELP) {
                  this.$bvModal.show("modal-view-help");
                }
              }
              this.loading(false);
            })
            .catch((err) => {
              this.loading(false);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: err.response?.data?.message,
                  icon: "AlertTriangleIcon",
                  variant: "warning",
                },
              });
            });
      }
    },
    isSelected: function (i) {
      return i === this.selected
    },
    dateFormat(v) {
      return moment(v, 'YYYYMMDDHHmmss').format('DD/MM/YYYY hh:mm:ss')
    },
    formatDate(v) {
      return moment(v, 'YYYY/MM/DD').format('DD/MM/YYYY')
    },

    async loadEmailConfig() {
      useJwt.get("portal/emailconfig").then((response) => {
        var result = response.data;
        if (result.code == 200) {
          result.result.forEach(item => {
            this.emalConfigs.push(item.email);
          });
        }

        this.isLoading = false;
        this.loading(false);
      });
    },

    showFeedback(itemNew) {
      this.feedbackItem = {};
      this.feedbackItem.new_group_id = itemNew.id;
      if (itemNew.name) {
        this.feedbackItem.newName = itemNew.name;
      } else {
        this.feedbackItem.newName = itemNew.question;
      }
      this.$bvModal.show("modal-feedback");
    },

    async handleFeedbackOk(bvModalEv) {
      bvModalEv.preventDefault();
      const userName = getuserName();
      if (!this.feedbackItem.contents || this.feedbackItem.contents.trim().length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải nhập nội dung góp ý!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }
      try {
        const createParams = {
          id: 0,
          new_group_id: this.feedbackItem.new_group_id,
          contents: this.feedbackItem.contents,
          notes: this.feedbackItem.notes,
          created_at: userName,
          emails: this.emalConfigs.join(','),
          newName: this.feedbackItem.newName,
          type: 0
        };
        this.loading(true);
        const res = await useJwt.post("portal/feedback", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.$bvModal.hide("modal-feedback");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Thêm mới ý kiến phản hồi!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }

      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi thêm mới ý kiến phản hồi ",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    showSMS(itemNew) {
      this.smsItem = {};
      this.smsItem.ref_id = itemNew.id;
      this.smsItem.newName = itemNew.answer;
      this.$bvModal.show("modal-sms");
    },

    async handleSMSOk(bvModalEv) {
      bvModalEv.preventDefault();
      const userName = getuserName();
      if (!this.smsItem.phone || this.smsItem.phone.trim().length < 10) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải số điện thoại nhận SMS!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }
      if (this.smsItem.phone.indexOf('087') != 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải số iTel (bắt đầu bằng 087)!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }
      if (!this.smsItem.contents || this.smsItem.contents.trim().length == 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Bạn phải nhập nội dung SMS!",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
        return false;
      }
      try {
        const createParams = {
          id: 0,
          ref_id: this.smsItem.ref_id,
          contents: this.smsItem.contents.trim(),
          phone: this.smsItem.phone,
          created_at: userName
        };
        this.loading(true);
        const res = await useJwt.post("portal/sms", createParams);
        this.loading(false);
        if (res.data.code == 200) {
          this.$bvModal.hide("modal-sms");
          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Gửi sms thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }

      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi gửi sms.",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async confirm() {
      try {
        this.loading(true);
        const res = await useJwt.post("portal/HotNew", {});
        this.loading(false);
        if (res.data.code == 200) {
          this.$bvModal.hide("modal-hot-new");

          return this.$toast({
            component: ToastificationContent,
            props: {
              title: "Xác nhận tin hot thành công!",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
        }
      } catch (error) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Lỗi xác nhận tin Hot",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
    async uploadFile() {
      try {
        this.loading(true);
        var formData = new FormData();
        formData.append("file", this.feedbackItem.file);
        const res = await useJwt.post(`portal/upload`, formData);
        if (res.data.code == 200) {
          this.feedbackItem.file_path = res.data.result;
        }
        this.loading(false);
      } catch (err) {
        this.loading(false);
      }

    },
    async downloadFile(filePath) {
      try {
        const downloadParams = {filePath: filePath};
        const arrFile = filePath.replaceAll('\\', '/').split('/');
        this.loading(true);
        const res = await useJwt.postDownload("portal/download", arrFile[1], downloadParams);
        this.loading(false);
      } catch (err) {
        this.loading(false);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "File không đúng hoặc không còn tồn tại.",
            icon: "AlertTriangleIcon",
            variant: "danger"
          },
        });
      }
    },
    checkedClick(node, item, e) {
      this.fetchNews();
    },
    itemClick(node, item, e) {
      if (node && node.data && node.data.cat_type == 1) {
      } else {
        if (node.model.opened) {
          node.model.opened = false;
        } else {
          node.model.opened = true;
        }
      }
    },
    // itemCtrlClick: function (node, e) {
    //   node.model.selected ^= true
    //   if (node.model.selected) {
    //     node.model.opened = false
    //     this.deselectNodeChildren(node)
    //     node.model.selected = true
    //   }
    //   e.stopPropagation()
    // },

    handleOk() {

    }
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-knowledge-base.scss";
</style>
<style lang="css">
.tree-default {
  margin-top: 14px;
}

/* .tree-default .tree-node {
  min-height: 50px !important;
  line-height: 50px !important;

} */

.tree-selected:last-child {
  background-color: #dfdfdf !important;
}

.tree-children {
  padding-left: 10px !important;
}

.tree-default .tree-anchor,
.tree-default .tree-icon,
.tree-default .tree-disabled {
  color: #000 !important;
  font-size: 15px;
  font-weight: bold;
}

/* .tree-children ul {
  max-height: none !important;
} */

.list-new .card-body {
  padding: 1rem !important;
  height: calc(100vh - 220px);
}

.nav-tabs .nav-link,
.nav-tabs .nav-item.show .nav-link {
  color: black;
}


.left {
  width: 400px;
  background: #fff;
  height: calc(100vh - 315px);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  overflow-y: auto;
  overflow-x: hidden;
}

.list-new .list-group {
  background: #fff;
  height: calc(100vh - 385px);
}

.right {
  width: calc(100% - 410px);
  padding-left: 10px;
  overflow-y: auto;
  overflow-x: hidden;
}

.title-cat {
  width: 100%;
  background: pink;
  height: 50px;
  text-align: center;
  vertical-align: middle;
  line-height: 50px;
  color: black;
  font-weight: bold;
  font-size: 15px;
}

.list-group-item:focus,
list-group-item:hover,
button.list-group-item:focus,
button.list-group-item:hover {
  color: #555;
  text-decoration: none;
  background-color: #dfdfdf !important;
  cursor: pointer;
}

.list-group-item.active,
.list-group-item.active:focus,
.list-group-item.active:hover {
  z-index: 2;
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
  cursor: pointer;
}

.list-group-item > span {
  cursor: pointer;
}

.modal .modal-header {
  background-color: #ed1f24;
  color: black !important;
}

.modal-header h5 {
  color: black !important;
}

.use-new label {
  line-height: 50px;
  font-size: 1rem;
}


.list-group.list-group-circle .list-group-item:hover,
.list-group .list-group-item:hover {
  background-color: rgb(34 41 47 / 10%) !important;
}

.question-content-break {
  min-height: 330px;
  white-space: break-spaces;
  line-height: 2.5rem;
}

/* .question-content p{
  display: inline-table;
  line-height: 0!important;
} */
.input-group-merge {
  cursor: pointer;
}

.list-group-item:focus,
list-group-item:hover,
button.list-group-item:focus,
button.list-group-item:hover {
  color: #555;
  text-decoration: none;
  background-color: rgb(34 41 47 / 10%) !important;
  cursor: pointer;
}

.list-group-item.active,
.list-group-item.active:focus,
.list-group-item.active:hover {
  z-index: 2;
  color: #fff;
  background-color: #337ab7;
  border-color: #337ab7;
  cursor: pointer;
}

.list-group-item > span {
  cursor: pointer;
}

.modal .modal-header {
  background-color: #ed1f24;
  color: black !important;
}

.modal-header h5 {
  color: black !important;
}


.not-padding {
  padding: 0 !important;
}

.not-padding-r {
  padding-right: 0 !important;
}

.phone-re {
  display: inline-block;
  width: 200px;
  margin-left: 20px;
  border: 1px solid #ddd;
  height: 30px;
  border-radius: 3px;
}

input:focus-visible {
  outline: none !important;
  border: 1px solid #ed1f24;
}

.is-read {
  opacity: 0.6;
}

.confirm-text {
  opacity: 0.6;
  color: #555;
  font-size: 11px !important;
}

.img-btn {
  width: 60px;
  cursor: pointer;
  margin: 0 20px;
}

.input-group-merge {
  cursor: pointer;
}

.list-group.list-group-circle .list-group-item:after {
  left: 10px;
  background-image: none;
}

.list-group.list-group-circle .list-group-item {
  padding-left: 2rem;
  text-align: left;
}

.search-new {
  height: 50px;
}


.modal-xl {
  max-width: 70% !important;
  margin: 0 auto;
  padding-top: 4rem;
}

#modal-view .modal-dialog, #modal-view-promotion .modal-dialog, #modal-view-help .modal-dialog, #modal-qa .modal-dialog, #modal-pack .modal-dialog {
  width: calc(100% - 560px) !important;
  margin-right: 40px;
  height: 100%;
  max-width: calc(100% - 560px) !important;
}

@media (max-width: 1480px) {

  .modal-xl {
    max-width: 80% !important;
  }
}

@media (max-width: 1280px) {
  .modal-xl {
    max-width: 85% !important;
  }
}

@media (max-width: 768px) {
  .left {
    width: 100%;
    height: calc(50vh - 100px);
    overflow-y: auto;
    overflow-x: hidden;
  }

  .right {
    width: 100%;
    height: calc(50vh - 100px);
    overflow-y: auto;
    overflow-x: hidden;
  }


  .list-new .list-group {
    background: #fff;
    height: calc(100vh - 385px);
  }

  .modal-xl {
    max-width: 95% !important;
  }

  .col-4,
  .col-3 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

@media (max-width: 480px) {

  .col-4,
  .col-3 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}


.use-new .form-group {
  border-bottom: 1px solid #ebe9f1;
}


.border-lr {
  border-left: 1px solid #ebe9f1;
  border-right: 1px solid #ebe9f1;
}

.border-left {
  border-left: 2px solid #ccc;
}

.font-bold {
  font-weight: bold;
}

.margin-b {
  margin-bottom: 0 !important;
}

.use-new .vgt-responsive {
  height: calc(100vh - 390px);
  background-color: #fff;
}

.hot-new {
  display: flex;
  width: 100%;
}

.hot-img {
  width: 240px;
}

.hot-grid {
  width: calc(100% - 240px);
}

.vgt-table td,
.vgt-table th {
  max-width: 300px;
}

.tree-disabled .tree-checkbox {
  display: none !important;
}
</style>
